import { AppType } from '../services/models/app-type';
import { useAccount } from './useAccount';

/**
 * It determines if an app is available as an integration for the current account.
 */
export const useAvailableIntegration = (appType: AppType): boolean => {
  const { account } = useAccount();
  const availableIntegrations = account?.availableIntegrations || [];
  return availableIntegrations.some(x => x === appType);
};
